module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "photo-full-screen",
    class: {
      'in': _vm.isIn
    }
  }, [_c('button', {
    staticClass: "close btn-link",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClose($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', [(_vm.previous !== null) ? _c('button', {
    staticClass: "btn btn-link previous",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goToIndex(_vm.previous)
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous Photo")]), _vm._v(" "), _c('span', [_vm._v("◀")])]) : _vm._e(), _vm._v(" "), (_vm.next) ? _c('button', {
    staticClass: "btn btn-link next",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goToIndex(_vm.next)
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next Photo")]), _vm._v(" "), _c('span', [_vm._v("▶")])]) : _vm._e()]), _vm._v(" "), _c('figure', [(_vm.hasSizesData) ? _c('img', {
    staticClass: "img-responsive img-loadable",
    class: {
      'loaded': _vm.imageLoaded
    },
    attrs: {
      "src": _vm.photoSource,
      "alt": _vm.meta.title._content
    },
    on: {
      "load": _vm.handleImageLoad
    }
  }) : _vm._e(), _vm._v(" "), _c('figcaption', {
    staticClass: "meta"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.meta.title._content))]), _vm._v(" "), (_vm.meta.description._content && _vm.meta.description._content !== '') ? _c('p', [_vm._v(_vm._s(_vm.meta.description._content))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a20e9c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotoFullScreen.vue
// module id = 119
// module chunks = 2